// .create-event-container {
// 	pointer-events: auto;
// 	height: auto;

import classNames from "classnames";
import FadeIn from "../../../../../../src/vendored/FadeIn";
import {
	DashboardUtils,
	FADE_IN_ANIMATION_DURATION,
} from "../../../dashboard_utils";

// TODO: fix shadow
export function DashboardContainer(props: {
	title?: JSX.Element | string;
	children: React.ReactNode;
	bread_crumbs?: JSX.Element;
	size?: "md" | "lg" | "xl";
	is_loading?: boolean;
	no_fade_in?: boolean;
}) {
	const content = (
		<div
			className={classNames(
				"m-auto flex w-11/12 flex-col bg-base-primary px-4 pb-8 pt-4 shadow-md sm:p-12",
				{
					"sm:w-3/4 xl:w-3/5 2xl:w-1/2":
						!props.size || props.size === "md",
					"sm:w-4/5 xl:w-3/5": props.size === "lg",
					"sm:w-11/12 xl:w-4/5": props.size === "xl",
				}
			)}
		>
			{props.bread_crumbs && <>{props.bread_crumbs}</>}
			{props.title && <div className="title mx-auto">{props.title}</div>}
			{props.is_loading ? (
				DashboardUtils.RenderLoadingThrobber()
			) : (
				<>{props.children}</>
			)}
		</div>
	);

	return props.no_fade_in ? (
		content
	) : (
		<FadeIn transitionDuration={FADE_IN_ANIMATION_DURATION}>
			{content}
		</FadeIn>
	);
}
